/**
 * Generated by orval v8.12.3 🍺
 * Do not edit manually.
 * TorqueTitan API
 * Auto repair shop management API
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  ApiError,
  Appointment,
  AppointmentResult,
  AvailableSlots,
  CreateAppointmentRequest,
  CreatePublicAppointmentRequest,
  GetAppointmentsParams,
  GetAvailableSlotsParams,
  ListAppointmentsResponse,
  PublicAppointment,
  ReschedulePublicRequest,
  UpdateAppointmentRequest,
} from './torqueTitanAPI.schemas';

import { apiFetcher } from '../apiFetcher';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

export const getGetAvailableSlotsUrl = (params: GetAvailableSlotsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/appointments/public/available-slots?${stringifiedParams}`
    : `/appointments/public/available-slots`;
};

/**
 * Returns available appointment slots for a shop on a given date.
 * @summary Get available time slots (public)
 */
export const getAvailableSlots = async (
  params: GetAvailableSlotsParams,
  options?: RequestInit
): Promise<AvailableSlots> => {
  return apiFetcher<AvailableSlots>(getGetAvailableSlotsUrl(params), {
    ...options,
    method: 'GET',
  });
};

export const getGetAvailableSlotsQueryKey = (params?: GetAvailableSlotsParams) => {
  return [`/appointments/public/available-slots`, ...(params ? [params] : [])] as const;
};

export const getGetAvailableSlotsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAvailableSlots>>,
  TError = ApiError,
>(
  params: GetAvailableSlotsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAvailableSlots>>, TError, TData>>;
    request?: SecondParameter<typeof apiFetcher>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAvailableSlotsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAvailableSlots>>> = ({ signal }) =>
    getAvailableSlots(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAvailableSlots>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAvailableSlotsQueryResult = NonNullable<Awaited<ReturnType<typeof getAvailableSlots>>>;
export type GetAvailableSlotsQueryError = ApiError;

export function useGetAvailableSlots<TData = Awaited<ReturnType<typeof getAvailableSlots>>, TError = ApiError>(
  params: GetAvailableSlotsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAvailableSlots>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAvailableSlots>>,
          TError,
          Awaited<ReturnType<typeof getAvailableSlots>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAvailableSlots<TData = Awaited<ReturnType<typeof getAvailableSlots>>, TError = ApiError>(
  params: GetAvailableSlotsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAvailableSlots>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAvailableSlots>>,
          TError,
          Awaited<ReturnType<typeof getAvailableSlots>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAvailableSlots<TData = Awaited<ReturnType<typeof getAvailableSlots>>, TError = ApiError>(
  params: GetAvailableSlotsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAvailableSlots>>, TError, TData>>;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get available time slots (public)
 */

export function useGetAvailableSlots<TData = Awaited<ReturnType<typeof getAvailableSlots>>, TError = ApiError>(
  params: GetAvailableSlotsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAvailableSlots>>, TError, TData>>;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAvailableSlotsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getCreatePublicAppointmentUrl = () => {
  return `/appointments/public`;
};

/**
 * Public endpoint for customers to book appointments. Requires reCAPTCHA.
 * @summary Book an appointment (public)
 */
export const createPublicAppointment = async (
  createPublicAppointmentRequest?: CreatePublicAppointmentRequest,
  options?: RequestInit
): Promise<AppointmentResult> => {
  return apiFetcher<AppointmentResult>(getCreatePublicAppointmentUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createPublicAppointmentRequest),
  });
};

export const getCreatePublicAppointmentMutationOptions = <TError = ApiError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPublicAppointment>>,
    TError,
    { data?: CreatePublicAppointmentRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiFetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createPublicAppointment>>,
  TError,
  { data?: CreatePublicAppointmentRequest },
  TContext
> => {
  const mutationKey = ['createPublicAppointment'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createPublicAppointment>>,
    { data?: CreatePublicAppointmentRequest }
  > = (props) => {
    const { data } = props ?? {};

    return createPublicAppointment(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreatePublicAppointmentMutationResult = NonNullable<Awaited<ReturnType<typeof createPublicAppointment>>>;
export type CreatePublicAppointmentMutationBody = CreatePublicAppointmentRequest | undefined;
export type CreatePublicAppointmentMutationError = ApiError;

/**
 * @summary Book an appointment (public)
 */
export const useCreatePublicAppointment = <TError = ApiError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createPublicAppointment>>,
      TError,
      { data?: CreatePublicAppointmentRequest },
      TContext
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createPublicAppointment>>,
  TError,
  { data?: CreatePublicAppointmentRequest },
  TContext
> => {
  return useMutation(getCreatePublicAppointmentMutationOptions(options), queryClient);
};
export const getGetPublicAppointmentUrl = (token: string) => {
  return `/appointments/public/${token}`;
};

/**
 * Public endpoint for customers to view their appointment details using a public token.
 * @summary Get appointment by public token
 */
export const getPublicAppointment = async (token: string, options?: RequestInit): Promise<PublicAppointment> => {
  return apiFetcher<PublicAppointment>(getGetPublicAppointmentUrl(token), {
    ...options,
    method: 'GET',
  });
};

export const getGetPublicAppointmentQueryKey = (token: string) => {
  return [`/appointments/public/${token}`] as const;
};

export const getGetPublicAppointmentQueryOptions = <
  TData = Awaited<ReturnType<typeof getPublicAppointment>>,
  TError = ApiError,
>(
  token: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicAppointment>>, TError, TData>>;
    request?: SecondParameter<typeof apiFetcher>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPublicAppointmentQueryKey(token);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPublicAppointment>>> = ({ signal }) =>
    getPublicAppointment(token, { signal, ...requestOptions });

  return { queryKey, queryFn, enabled: token !== null && token !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPublicAppointment>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPublicAppointmentQueryResult = NonNullable<Awaited<ReturnType<typeof getPublicAppointment>>>;
export type GetPublicAppointmentQueryError = ApiError;

export function useGetPublicAppointment<TData = Awaited<ReturnType<typeof getPublicAppointment>>, TError = ApiError>(
  token: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicAppointment>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPublicAppointment>>,
          TError,
          Awaited<ReturnType<typeof getPublicAppointment>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPublicAppointment<TData = Awaited<ReturnType<typeof getPublicAppointment>>, TError = ApiError>(
  token: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicAppointment>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPublicAppointment>>,
          TError,
          Awaited<ReturnType<typeof getPublicAppointment>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPublicAppointment<TData = Awaited<ReturnType<typeof getPublicAppointment>>, TError = ApiError>(
  token: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicAppointment>>, TError, TData>>;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get appointment by public token
 */

export function useGetPublicAppointment<TData = Awaited<ReturnType<typeof getPublicAppointment>>, TError = ApiError>(
  token: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicAppointment>>, TError, TData>>;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetPublicAppointmentQueryOptions(token, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getCancelPublicAppointmentUrl = (token: string) => {
  return `/appointments/public/${token}/cancel`;
};

/**
 * Public endpoint for customers to cancel their appointment using a public token.
 * @summary Cancel appointment by public token
 */
export const cancelPublicAppointment = async (token: string, options?: RequestInit): Promise<void> => {
  return apiFetcher<void>(getCancelPublicAppointmentUrl(token), {
    ...options,
    method: 'PATCH',
  });
};

export const getCancelPublicAppointmentMutationOptions = <TError = ApiError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cancelPublicAppointment>>,
    TError,
    { token: string },
    TContext
  >;
  request?: SecondParameter<typeof apiFetcher>;
}): UseMutationOptions<Awaited<ReturnType<typeof cancelPublicAppointment>>, TError, { token: string }, TContext> => {
  const mutationKey = ['cancelPublicAppointment'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelPublicAppointment>>, { token: string }> = (
    props
  ) => {
    const { token } = props ?? {};

    return cancelPublicAppointment(token, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CancelPublicAppointmentMutationResult = NonNullable<Awaited<ReturnType<typeof cancelPublicAppointment>>>;

export type CancelPublicAppointmentMutationError = ApiError;

/**
 * @summary Cancel appointment by public token
 */
export const useCancelPublicAppointment = <TError = ApiError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof cancelPublicAppointment>>,
      TError,
      { token: string },
      TContext
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof cancelPublicAppointment>>, TError, { token: string }, TContext> => {
  return useMutation(getCancelPublicAppointmentMutationOptions(options), queryClient);
};
export const getReschedulePublicAppointmentUrl = (token: string) => {
  return `/appointments/public/${token}/reschedule`;
};

/**
 * Public endpoint for customers to reschedule their appointment using a public token.
 * @summary Reschedule appointment by public token
 */
export const reschedulePublicAppointment = async (
  token: string,
  reschedulePublicRequest?: ReschedulePublicRequest,
  options?: RequestInit
): Promise<PublicAppointment> => {
  return apiFetcher<PublicAppointment>(getReschedulePublicAppointmentUrl(token), {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(reschedulePublicRequest),
  });
};

export const getReschedulePublicAppointmentMutationOptions = <TError = ApiError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reschedulePublicAppointment>>,
    TError,
    { token: string; data?: ReschedulePublicRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiFetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof reschedulePublicAppointment>>,
  TError,
  { token: string; data?: ReschedulePublicRequest },
  TContext
> => {
  const mutationKey = ['reschedulePublicAppointment'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof reschedulePublicAppointment>>,
    { token: string; data?: ReschedulePublicRequest }
  > = (props) => {
    const { token, data } = props ?? {};

    return reschedulePublicAppointment(token, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReschedulePublicAppointmentMutationResult = NonNullable<
  Awaited<ReturnType<typeof reschedulePublicAppointment>>
>;
export type ReschedulePublicAppointmentMutationBody = ReschedulePublicRequest | undefined;
export type ReschedulePublicAppointmentMutationError = ApiError;

/**
 * @summary Reschedule appointment by public token
 */
export const useReschedulePublicAppointment = <TError = ApiError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof reschedulePublicAppointment>>,
      TError,
      { token: string; data?: ReschedulePublicRequest },
      TContext
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof reschedulePublicAppointment>>,
  TError,
  { token: string; data?: ReschedulePublicRequest },
  TContext
> => {
  return useMutation(getReschedulePublicAppointmentMutationOptions(options), queryClient);
};
export const getGetAppointmentsUrl = (params?: GetAppointmentsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/appointments?${stringifiedParams}` : `/appointments`;
};

/**
 * Returns appointments for a date range and/or customer, optionally filtered by status.
 * @summary List appointments
 */
export const getAppointments = async (
  params?: GetAppointmentsParams,
  options?: RequestInit
): Promise<ListAppointmentsResponse> => {
  return apiFetcher<ListAppointmentsResponse>(getGetAppointmentsUrl(params), {
    ...options,
    method: 'GET',
  });
};

export const getGetAppointmentsQueryKey = (params?: GetAppointmentsParams) => {
  return [`/appointments`, ...(params ? [params] : [])] as const;
};

export const getGetAppointmentsQueryOptions = <TData = Awaited<ReturnType<typeof getAppointments>>, TError = ApiError>(
  params?: GetAppointmentsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAppointments>>, TError, TData>>;
    request?: SecondParameter<typeof apiFetcher>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAppointmentsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAppointments>>> = ({ signal }) =>
    getAppointments(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAppointments>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAppointmentsQueryResult = NonNullable<Awaited<ReturnType<typeof getAppointments>>>;
export type GetAppointmentsQueryError = ApiError;

export function useGetAppointments<TData = Awaited<ReturnType<typeof getAppointments>>, TError = ApiError>(
  params: undefined | GetAppointmentsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAppointments>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAppointments>>,
          TError,
          Awaited<ReturnType<typeof getAppointments>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAppointments<TData = Awaited<ReturnType<typeof getAppointments>>, TError = ApiError>(
  params?: GetAppointmentsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAppointments>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAppointments>>,
          TError,
          Awaited<ReturnType<typeof getAppointments>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAppointments<TData = Awaited<ReturnType<typeof getAppointments>>, TError = ApiError>(
  params?: GetAppointmentsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAppointments>>, TError, TData>>;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List appointments
 */

export function useGetAppointments<TData = Awaited<ReturnType<typeof getAppointments>>, TError = ApiError>(
  params?: GetAppointmentsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAppointments>>, TError, TData>>;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAppointmentsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getCreateAppointmentUrl = () => {
  return `/appointments`;
};

/**
 * Creates an appointment for an existing customer and vehicle. Auto-creates a repair order.
 * @summary Create an appointment (internal)
 */
export const createAppointment = async (
  createAppointmentRequest?: CreateAppointmentRequest,
  options?: RequestInit
): Promise<AppointmentResult> => {
  return apiFetcher<AppointmentResult>(getCreateAppointmentUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createAppointmentRequest),
  });
};

export const getCreateAppointmentMutationOptions = <TError = ApiError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAppointment>>,
    TError,
    { data?: CreateAppointmentRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiFetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createAppointment>>,
  TError,
  { data?: CreateAppointmentRequest },
  TContext
> => {
  const mutationKey = ['createAppointment'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createAppointment>>,
    { data?: CreateAppointmentRequest }
  > = (props) => {
    const { data } = props ?? {};

    return createAppointment(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateAppointmentMutationResult = NonNullable<Awaited<ReturnType<typeof createAppointment>>>;
export type CreateAppointmentMutationBody = CreateAppointmentRequest | undefined;
export type CreateAppointmentMutationError = ApiError;

/**
 * @summary Create an appointment (internal)
 */
export const useCreateAppointment = <TError = ApiError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createAppointment>>,
      TError,
      { data?: CreateAppointmentRequest },
      TContext
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createAppointment>>,
  TError,
  { data?: CreateAppointmentRequest },
  TContext
> => {
  return useMutation(getCreateAppointmentMutationOptions(options), queryClient);
};
export const getGetAppointmentUrl = (id: string) => {
  return `/appointments/${id}`;
};

/**
 * Retrieves a single appointment by its unique identifier.
 * @summary Get appointment by ID
 */
export const getAppointment = async (id: string, options?: RequestInit): Promise<Appointment> => {
  return apiFetcher<Appointment>(getGetAppointmentUrl(id), {
    ...options,
    method: 'GET',
  });
};

export const getGetAppointmentQueryKey = (id: string) => {
  return [`/appointments/${id}`] as const;
};

export const getGetAppointmentQueryOptions = <TData = Awaited<ReturnType<typeof getAppointment>>, TError = ApiError>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAppointment>>, TError, TData>>;
    request?: SecondParameter<typeof apiFetcher>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAppointmentQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAppointment>>> = ({ signal }) =>
    getAppointment(id, { signal, ...requestOptions });

  return { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAppointment>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAppointmentQueryResult = NonNullable<Awaited<ReturnType<typeof getAppointment>>>;
export type GetAppointmentQueryError = ApiError;

export function useGetAppointment<TData = Awaited<ReturnType<typeof getAppointment>>, TError = ApiError>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAppointment>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAppointment>>,
          TError,
          Awaited<ReturnType<typeof getAppointment>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAppointment<TData = Awaited<ReturnType<typeof getAppointment>>, TError = ApiError>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAppointment>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAppointment>>,
          TError,
          Awaited<ReturnType<typeof getAppointment>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAppointment<TData = Awaited<ReturnType<typeof getAppointment>>, TError = ApiError>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAppointment>>, TError, TData>>;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get appointment by ID
 */

export function useGetAppointment<TData = Awaited<ReturnType<typeof getAppointment>>, TError = ApiError>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAppointment>>, TError, TData>>;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAppointmentQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getUpdateAppointmentUrl = (id: string) => {
  return `/appointments/${id}`;
};

/**
 * Updates an existing appointment by ID.
 * @summary Update an appointment
 */
export const updateAppointment = async (
  id: string,
  updateAppointmentRequest?: UpdateAppointmentRequest,
  options?: RequestInit
): Promise<Appointment> => {
  return apiFetcher<Appointment>(getUpdateAppointmentUrl(id), {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateAppointmentRequest),
  });
};

export const getUpdateAppointmentMutationOptions = <TError = ApiError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAppointment>>,
    TError,
    { id: string; data?: UpdateAppointmentRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiFetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateAppointment>>,
  TError,
  { id: string; data?: UpdateAppointmentRequest },
  TContext
> => {
  const mutationKey = ['updateAppointment'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateAppointment>>,
    { id: string; data?: UpdateAppointmentRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateAppointment(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateAppointmentMutationResult = NonNullable<Awaited<ReturnType<typeof updateAppointment>>>;
export type UpdateAppointmentMutationBody = UpdateAppointmentRequest | undefined;
export type UpdateAppointmentMutationError = ApiError;

/**
 * @summary Update an appointment
 */
export const useUpdateAppointment = <TError = ApiError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateAppointment>>,
      TError,
      { id: string; data?: UpdateAppointmentRequest },
      TContext
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateAppointment>>,
  TError,
  { id: string; data?: UpdateAppointmentRequest },
  TContext
> => {
  return useMutation(getUpdateAppointmentMutationOptions(options), queryClient);
};
